import { Attachment } from 'ish-core/models/attachment/attachment.model';
import { AttributeGroup } from 'ish-core/models/attribute-group/attribute-group.model';
import { Attribute } from 'ish-core/models/attribute/attribute.model';
import { Image } from 'ish-core/models/image/image.model';
import { Price } from 'ish-core/models/price/price.model';
import { VariationAttribute } from 'ish-core/models/product-variation/variation-attribute.model';
import { SeoAttributes } from 'ish-core/models/seo-attributes/seo-attributes.model';
import { Warranty } from 'ish-core/models/warranty/warranty.model';

export interface Product {
  name: string;
  shortDescription: string;
  longDescription: string;
  available: boolean;
  availableStock?: number;
  minOrderQuantity: number;
  maxOrderQuantity: number;
  stepQuantity: number;
  attributes: Attribute[];
  attributeGroups?: { [id: string]: AttributeGroup };
  attachments?: Attachment[];
  images: Image[];
  manufacturer: string;
  roundedAverageRating: number;
  numberOfReviews: number;
  readyForShipmentMin: number;
  readyForShipmentMax: number;
  sku: string;
  defaultCategoryId?: string;
  packingUnit: string;

  availableWarranties?: Warranty[];

  // properties added in model
  type: string;
  promotionIds: string[];
  completenessLevel: number;
  failed: boolean;
  seoAttributes?: SeoAttributes;

  /* DIAS CUSTOMIZATION START */
  salePrice?: Price;
  /* DIAS CUSTOMIZATION END */
}

export interface VariationProduct extends Product {
  type: 'VariationProduct';
  variableVariationAttributes?: VariationAttribute[];
  productMasterSKU?: string;
}

export interface VariationProductMaster extends Product {
  type: 'VariationProductMaster';
  variationAttributeValues?: VariationAttribute[];
}

export interface ProductRetailSet extends Product {
  type: 'RetailSet';
}

export interface ProductBundle extends Product {
  type: 'Bundle';
}

export type AllProductTypes = Product | VariationProduct | VariationProductMaster | ProductBundle | ProductRetailSet;

export * from './product.helper';

/* DIAS CUSTOMIZATION START */

export const PRODUCT_ATTRIBUTES: string[] = [
  'attachments',
  'availability',
  'availableGiftMessages',
  'availableGiftWraps',
  'availableStock',
  'availableWarranties',
  'averageRating',
  'bundles',
  'crosssells',
  'currencyCode',
  'customAttributes',
  'defaultCategory',
  'endOfLife',
  'images',
  'inStock',
  'lastOrderDate',
  'listPrice',
  'manufacturer',
  'manufacturerSKU',
  'mastered',
  'maxListPrice',
  'maxOrderQuantity',
  'maxSalePrice',
  'minListPrice',
  'minOrderQuantity',
  'minSalePrice',
  'packingUnit',
  'partOfRetailSet',
  'price',
  'productBundle',
  'productMaster',
  'productMasterSKU',
  'productName',
  'productTypes',
  'promotions',
  'readyForShipmentMax',
  'readyForShipmentMin',
  'retailSet',
  'reviews',
  'roundedAverageRating',
  'salePrice',
  'seoAttributes',
  'shippingMethods',
  'shortDescription',
  'sku',
  'stepOrderQuantity',
  'summedUpListPrice',
  'summedUpSalePrice',
  'supplier',
  'supplierSKU',
  'timeToDelivery',
  'variations',
  'variationAttributeValues',
  'variableVariationAttributes',
  'longDescription',
];
/* DIAS CUSTOMIZATION END */
